import Collapsible from 'src/components/Collapsible/Collapsible';
import useCollapsibleState from 'src/components/Collapsible/hooks/useCollapsibleState';
import Chevron from 'src/components/Icons/Chevron';
import { cm } from 'src/utils/classNames';

interface Props {
	hideToggle?: boolean;
	children: React.ReactNode;
	toggleClassName?: string;
	label: string;
	localStorageKey: string;
	endContent?: React.ReactNode;
	contentClassName?: string;
}

export default function TradeFormCollapsible({
	hideToggle,
	children,
	toggleClassName,
	label,
	localStorageKey,
	endContent,
	contentClassName,
}: Props) {
	const [isExpanded, toggleExpanded] = useCollapsibleState({
		localStorageKey,
	});

	return (
		<div className="typo-body-xs text-text-secondary">
			<Collapsible.Root
				open={hideToggle ? true : isExpanded}
				onOpenChange={toggleExpanded}
			>
				{!hideToggle && (
					<Collapsible.Trigger
						className={cm(
							'flex w-full items-center justify-between',
							'text-text-secondary hover:text-text-default',
							toggleClassName
						)}
					>
						{label}
						<div className="flex items-center gap-x-xs">
							<span className="text-text-default">{endContent}</span>
							<Chevron direction={isExpanded ? 'up' : 'down'} />
						</div>
					</Collapsible.Trigger>
				)}
				<Collapsible.Content className={contentClassName}>
					{children}
				</Collapsible.Content>
			</Collapsible.Root>
		</div>
	);
}
